import { useContext } from "react";
import { InfrastructureContext } from "src/app/infrastructure/Infrastructure.context";
import { CustomerSettingsContext } from "src/app/infrastructure/wrappers/CustomerSettingsWrapper";

export const useInfrastructureContext = () => useContext(InfrastructureContext);
export const useCustomerSettingsContext = () => useContext(CustomerSettingsContext);

